export default __webpack_public_path__ + "static/media/error-icon.1664dba8.png";